export default "__VITE_ASSET__23035b10__"